import { UploadCloud } from "lucide-react"

interface FormatBadge {
  label: string
  /** Any Tailwind text-color class, e.g. "text-[#7ED321]" or "text-grey5" */
  colorClass: string
}

interface FileUploadIllustrationProps {
  /** Exactly two format badges: first appears top-right, second bottom-left */
  formats: [FormatBadge, FormatBadge]
}

export function FileUploadIllustration({ formats }: FileUploadIllustrationProps) {
  const [topRight, bottomLeft] = formats
  return (
    <div className="relative flex h-20 w-20 items-center justify-center rounded-full border border-grey4 bg-grey1">
      <UploadCloud size={32} className="text-white" />
      <span
        className={`font-mono absolute -right-6 -top-2 flex h-[22px] items-center rounded border border-grey4 bg-grey3 px-2 text-[11px] font-medium ${topRight.colorClass}`}
      >
        {topRight.label}
      </span>
      <span
        className={`font-mono absolute -bottom-2 -left-6 flex h-[22px] items-center rounded border border-grey4 bg-grey3 px-2 text-[11px] font-medium ${bottomLeft.colorClass}`}
      >
        {bottomLeft.label}
      </span>
    </div>
  )
}
